$(document).ready(function () {
    $('#date').flatpickr({
        enableTime: false,
        dateFormat: 'Y-m-d',
        minDate: "today"
    });

    $('#time').flatpickr({
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i"
    });
});
